import PropTypes from 'prop-types';

import {OETargetMenu} from '../../../elements/target-menu/oe-target-menu';
import {OEFNStartSelectionPropTypes} from '../../../views/flow-nav/start-selection/oe-fn-start-selection-model';

export const OEStdCapBarLayoutType = {
    min:                                    'min',
    singleRow:                              'single-row',
    twoRow:                                 'two-row',
    threeRow:                               'three-row'
};

export const OEStdCapBarTargetTypeFlags = {
    disableUnconnected:                     1,
    noTooltip:                              2,
    default:                                1
};

export const OEStdCapBarPropTypes = {

    targetTypeButton: PropTypes.shape({
        icon:                               PropTypes.string,
        label:                              PropTypes.string,
        disabled:                           PropTypes.bool,
        activated:                          PropTypes.bool,
        onPressed:                          PropTypes.func,
        onDisabledPressed:                  PropTypes.func,
        userData:                           PropTypes.any,
        tooltip:                            PropTypes.string,
        disabledTooltip:                    PropTypes.string,
    }),

    targetBarButton: PropTypes.shape({
        className:                          PropTypes.string,
        disabled:                           PropTypes.bool,
        activated:                          PropTypes.bool,
        onPressed:                          PropTypes.func,
        onDisabledPressed:                  PropTypes.func,
        icon:                               PropTypes.string
    })
};

OEStdCapBarPropTypes.targetTypeDecl = {
    id:                                 PropTypes.string.isRequired,
    target:                             PropTypes.string,
    disabled:                           PropTypes.bool,
    icon:                               PropTypes.string,
    noTargetTypeBarEntry:               PropTypes.bool,
    label:                              PropTypes.string,
    labelId:                            PropTypes.string,
    title:                              PropTypes.string,
    titleId:                            PropTypes.string,
    tooltip:                            PropTypes.string,
    tooltipId:                          PropTypes.string,
    disabledTooltip:                    PropTypes.string,
    disabledTooltipId:                  PropTypes.string,
    targetBarButton:                    OEStdCapBarPropTypes.targetBarButton,
    targetMenuEntries:                  OETargetMenu.propTypes.entries,
    targetMenuDisabled:                 PropTypes.bool,
    targetMenuHidden:                   PropTypes.bool,
    flags:                              PropTypes.number,
    onTargetMenuDisabledToggle:         PropTypes.func,
    startSelection:                     OEFNStartSelectionPropTypes.content
};

OEStdCapBarPropTypes.targetType = PropTypes.shape(OEStdCapBarPropTypes.targetTypeDecl);

OEStdCapBarPropTypes.targetTypes = PropTypes.arrayOf(OEStdCapBarPropTypes.targetType);